type WithStoreId = { id?: string | number };

export const PINNED_STORE_IDS = ['36070', '41150', '34990'];

const PINNED_STORE_INDEX = new Map(PINNED_STORE_IDS.map((id, index) => [id, index]));

export const prioritizeStoresByPinnedIds = <T extends WithStoreId>(stores: T[] = []): T[] => {
    const pinnedStoresById = new Map<string, T>();

    stores.forEach((store) => {
        const storeId = String(store?.id ?? '').trim();
        if (PINNED_STORE_INDEX.has(storeId)) {
            pinnedStoresById.set(storeId, store);
        }
    });

    const prioritizedPinnedStores = PINNED_STORE_IDS.map((id) => pinnedStoresById.get(id)).filter(
        (store): store is T => !!store,
    );

    if (!prioritizedPinnedStores.length) {
        return stores;
    }

    let pinnedCursor = 0;

    return stores.map((store) => {
        const storeId = String(store?.id ?? '').trim();
        if (!PINNED_STORE_INDEX.has(storeId)) {
            return store;
        }

        const prioritizedStore = prioritizedPinnedStores[pinnedCursor];
        pinnedCursor += 1;

        return prioritizedStore ?? store;
    });
};
